import { Icon, Spin } from 'antdV3';
import { UNUSUAL_REDIRECT_LOCAL_STORAGE_KEY } from 'authentication/constants';
import { useDidMount } from 'beautiful-react-hooks';
import { LoginRequest } from 'core/services/auth/auth.actions';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import type { AppState } from 'redux/app-state';

const LoginOauth2 = () => {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isLogged = useSelector((state: AppState) => state.uiState.auth.isLogged);
  const dispatch = useDispatch();

  useDidMount(() => {
    if (!searchParams.get('code')) return;

    dispatch(LoginRequest(searchParams.get('code')));
  });

  useEffect(() => {
    if (isLogged || (localStorage.getItem('access_token') && localStorage.getItem('refresh_token'))) {
      const linkAccessed = localStorage.getItem(UNUSUAL_REDIRECT_LOCAL_STORAGE_KEY);

      navigate(linkAccessed || '/hall-of-companies');
      localStorage.removeItem(UNUSUAL_REDIRECT_LOCAL_STORAGE_KEY);
    }
  }, [isLogged, navigate]);

  return (
    <div className='login-oauth2'>
      <Spin
        indicator={<Icon type='loading' style={{ fontSize: 24 }} spin />}
        tip={t('pages.smart_spray.loading_info') !== 'pages.smart_spray.loading_info' ? t('pages.smart_spray.loading_info') : ''}
        spinning
        delay={0}
      />
    </div>
  );
};

export default LoginOauth2;
